/** The campaign composer's phone preview (captain-approved round-4 design):
 *  an iPhone-shaped frame (island, status bar, sender avatar, home bar) that
 *  shows the message exactly as it lands, placeholders already expanded by
 *  the caller via the same renderTemplate the send path uses. Distinct from
 *  the wizard's PhonePreview, which previews the offer page, not the SMS. */
export function IphonePreview({
  body,
  imageUrl,
  storeName,
  storePhone,
}: {
  body: string;
  imageUrl?: string | null;
  storeName: string;
  storePhone: string | null;
}) {
  const initials = storeName
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");

  return (
    <div className="mx-auto flex w-full max-w-[260px] flex-col items-center gap-2">
      <div
        className="flex min-h-[440px] w-full flex-col rounded-[2.1rem] border-[6px] border-foreground bg-card px-3 pb-4 shadow-md"
        aria-label="Message preview"
      >
        <div className="mx-auto mt-2 h-5 w-20 rounded-full bg-foreground" aria-hidden="true" />
        <div className="mt-1 flex justify-between px-1 text-[10px] font-semibold text-foreground" aria-hidden="true">
          <span>11:02</span>
          <span>5G</span>
        </div>
        <div className="mx-auto mt-3 flex h-9 w-9 items-center justify-center rounded-full bg-action-primary text-xs font-bold text-action-primary-foreground">
          {initials || "?"}
        </div>
        <p className="mt-1 text-center text-[11px] text-muted-foreground">
          {storeName}
          {storePhone ? ` · ${storePhone}` : ""}
        </p>
        <p className="mt-2 text-center text-[10px] text-muted-foreground">Today 11:02 AM</p>
        <div className="mt-2 max-w-[92%] self-start rounded-2xl rounded-bl-sm bg-muted px-3 py-2 text-xs leading-relaxed text-foreground">
          {imageUrl && <img src={imageUrl} alt="" className="mb-2 max-h-28 w-full rounded-lg object-cover" />}
          <span className="whitespace-pre-wrap break-words">{body || "Your message preview appears here."}</span>
        </div>
        <p className="ml-2 mt-1 text-[10px] text-muted-foreground">Delivered</p>
        <div className="mx-auto mt-auto h-1 w-24 rounded-full bg-border" aria-hidden="true" />
      </div>
      <p className="text-center text-xs text-muted-foreground">Exactly how the text lands, link expanded.</p>
    </div>
  );
}
